import React, { FC } from 'react'
import { DashBoard } from 'src/components/Dashboard'
import { withLoginLayout } from 'src/components/Layout'

const Home: FC = () => {
  return <DashBoard />
}

export default withLoginLayout(Home)
